// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/header/header.component.scss
// module id = 345
// module chunks = 0